import * as React from "react";

export const BookIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="none"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="#fff"
      d="M.625 8.625a8 8 0 0 1 8-8h12a8 8 0 0 1 8 8v12a8 8 0 0 1-8 8h-12a8 8 0 0 1-8-8z"
    ></path>
    <path
      fill="#CDD3DC"
      d="M8.625.625v.625h12V0h-12zm20 8H28v12h1.25v-12zm-8 20V28h-12v1.25h12zm-20-8h.625v-12H0v12zm8 8V28a7.375 7.375 0 0 1-7.375-7.375H0a8.625 8.625 0 0 0 8.625 8.625zm20-8H28A7.375 7.375 0 0 1 20.625 28v1.25a8.625 8.625 0 0 0 8.625-8.625zm-8-20v.625A7.375 7.375 0 0 1 28 8.625h1.25A8.625 8.625 0 0 0 20.625 0zm-12 0V0A8.625 8.625 0 0 0 0 8.625h1.25A7.375 7.375 0 0 1 8.625 1.25z"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M14.625 20.345a5.3 5.3 0 0 0-6.243-.933c-.57.304-1.257-.07-1.257-.716V11.12c0-.53.245-1.04.677-1.348a5.304 5.304 0 0 1 6.823.573 5.304 5.304 0 0 1 6.823-.573c.432.308.677.818.677 1.348v7.576c0 .645-.687 1.02-1.257.716a5.3 5.3 0 0 0-6.243.933"
    ></path>
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M14.625 20.341v-10"
    ></path>
  </svg>
);
